module.exports = __webpack_public_path__ + "img/1.aff06c62.png";